export default __webpack_public_path__ + "static/media/validasi-kepala-gudang.7bded199.png";